import { render, staticRenderFns } from "./AdTiktokGoals.vue?vue&type=template&id=36923c10&scoped=true&"
import script from "./AdTiktokGoals.vue?vue&type=script&lang=js&"
export * from "./AdTiktokGoals.vue?vue&type=script&lang=js&"
import style0 from "./AdTiktokGoals.vue?vue&type=style&index=0&id=36923c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36923c10",
  null
  
)

export default component.exports